import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import auth from './modules/auth'
import managers from './modules/managers'
import components from './modules/components'
import applicants from './modules/applicants'
import tasks from './modules/tasks'
import contacts from './modules/contacts'
import activities from './modules/activities'
import toast from './modules/toast'

Vue.use(Vuex)

export const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      key: 'token',
      paths: ['auth.isLoggedIn', 'auth.user', 'auth.paymentPlans']
    })
  ],
  modules: {
    auth,
    managers,
    components,
    applicants,
    tasks,
    contacts,
    activities,
    toast
  }
})
